/**
 * Lazy PDF.js loader (CDN, v3.11.174) — shared by the sketch tool and QC markup.
 * Injects the library + worker once and resolves window.pdfjsLib.
 */

const PDFJS_VERSION = '3.11.174'
const BASE = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VERSION

let loadPromise = null

export function loadPdfjs() {
  if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib)
  if (loadPromise) return loadPromise
  loadPromise = new Promise((resolve) => {
    const s = document.createElement('script')
    s.src = BASE + '/pdf.min.js'
    s.onload = () => {
      try {
        if (window.pdfjsLib && window.pdfjsLib.GlobalWorkerOptions) {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = BASE + '/pdf.worker.min.js'
        }
      } catch { /* fake worker fallback */ }
      resolve(window.pdfjsLib)
    }
    s.onerror = () => resolve(window.pdfjsLib)
    document.head.appendChild(s)
  })
  return loadPromise
}
